import { render, staticRenderFns } from "./setpass.vue?vue&type=template&id=309c7229&scoped=true&"
import script from "./setpass.vue?vue&type=script&lang=js&"
export * from "./setpass.vue?vue&type=script&lang=js&"
import style0 from "./setpass.vue?vue&type=style&index=0&id=309c7229&lang=scss&scoped=true&"
import style1 from "./setpass.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309c7229",
  null
  
)

export default component.exports